<template >
  <splash></splash>
  <div class="container mt-4" dir="rtl">

      <sidebar></sidebar>

      <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5 p-2">
        <div class="card card-body card-panel-box border-0" >
      <div class="bg-info rounded">
        <h3 class="text-white mt-2">تحلیل تازه واردین</h3>
        <TazeVaredin v-for="item in type_one"  :id_item="item.id" :name="item.name"/>
      </div>
          <div class="bg-info rounded mt-3">
            <h3 class="text-white mt-2">جذابیت موانع خروج</h3>
      <MavaneKhoroj v-for="item in type_one"  :id_item="item.id" :name="item.name"/>
          </div>

          <div class="bg-info rounded mt-3">
            <h3 class="text-white mt-2">ﺟﺬﺍﺑﯿﺖ چشم ﻭ ﻫم چشمی ﺑﯿﻦ ﺭﻗﺒﺎ</h3>
          <HamCheshmi v-for="item in type_one"  :id_item="item.id" :name="item.name" />
          </div>
          <div class="bg-info rounded mt-3">
            <h3 class="text-white mt-2">تحلیل جایگزین ها</h3>
            <Jaygozinha v-for="item in type_one"  :id_item="item.id" :name="item.name" />
          </div>

          <div class="bg-info rounded mt-3">
            <h3 class="text-white mt-2">ﻗﺪﺭﺕ چاﻧﻪ ﺯنی ﻣﺸﺘﺮﯾﺎﻥ ﻧﻬﺎیی (مشترکین صنعتی)</h3>
            <ChaneZani v-for="item in type_two"  :id_item="item.id" :name="item.name" />
          </div>
          <div class="bg-info rounded mt-3">
            <h3 class="text-white mt-2">ﺟﺬﺍﺑﯿﺖ ﻗﺪﺭﺕ ﺗﺄﻣﯿﻦ کنندگاﻥ (تامین کنندگان خدمات)</h3>
            <TaminKonandegan v-for="item in type_tree"  :id_item="item.id" :name="item.name" />
          </div>
          <div class="bg-info rounded mt-3">
            <h3 class="text-white mt-2">جذابیت اقدامات دولت</h3>
            <EghdamatDolat/>
          </div>

    </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";
import Reset from "@/components/Icons/Reset.vue";
import ChaneZani from "@/components/5f/ChaneZani.vue";
import Jaygozinha from "@/components/5f/Jaygozinha.vue";
import EghdamatDolat from "@/components/5f/EghdamatDolat.vue";
import TaminKonandegan from "@/components/5f/TaminKonandegan.vue";
import MavaneKhoroj from "@/components/5f/MavaneKhoroj.vue";
import TazeVaredin from "@/components/5f/TazeVaredin.vue";
import HamCheshmi from "@/components/5f/HamCheshmi.vue";

export default {
  name: 'HomeView',
  data(){
    return{
      is_update: false,
      type_one: [],
      type_two: [],
      type_tree: [],

    }
  },
  components: {
    HamCheshmi,
    TazeVaredin,
    MavaneKhoroj,
    TaminKonandegan,
    EghdamatDolat,
    Jaygozinha,
    ChaneZani,
    Reset,
    Sidebar,
    splash
  },
  methods:{
    all(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var url = new URL(`${this.base_url}/BasicDefinitionsFiveF/show_all`);

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(url, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.type_one = [...response.type_one]
            this.type_two = [...response.type_two]
            this.type_tree = [...response.type_tree]
          })
          .catch(error => console.error('Error:', error));
    },
    checkIsMother(){
      if (this.is_mother){
        router.push('/mother_items')
        return
      }

    }
  },
  mounted() {
    this.checkIsMother()
    this.all()
  }
}
</script>
<style scoped lang="scss">
a{
  font-size: 1vw;
}
.card:not(:last-child){
  height: 12vw;
}
.btn-submit-1{
  width: 18vw !important;
}
/*.line_after{
  position: relative;
  &::after{
    position: absolute;
    width: 0.01vw;
    height: 53vw;
    content: '';
    background-color: #efecf3 !important;
    top: 5vw;
    right: 35.3vw ;
    border-radius: 1vw;
  }
}*/
p{
  font-size: 1vw;
}

</style>